import React from 'react';
import { Link } from 'react-router-dom';
import { useReveal } from '../lib/useReveal';

const OFFERS = [
  ['Client Entertainment', 'Private dining and progressive culinary experiences designed to strengthen relationships and unlock conversation.'],
  ['Executive Hosting', 'Discreet, high-touch experiences for board members, investors and VIP guests — hosted with absolute composure.'],
  ['Team Rewards', 'Premium food and wine experiences that feel more considered than a standard team dinner, without losing warmth.'],
  ['Conference Guest Experiences', 'Curated local dining and regional escapes for interstate and international attendees during major engagements.'],
];

export default function Corporate() {
  const ref = useReveal();
  return (
    <div ref={ref} data-testid="corporate-page" className="pt-36 sm:pt-44 lg:pt-56">
      <section className="grid lg:grid-cols-12 gap-0 items-stretch">
        <div className="lg:col-span-6 px-6 lg:px-16 py-12 lg:py-24 flex items-center">
          <div className="max-w-xl reveal">
            <div className="tdt-eyebrow mb-5">Corporate &amp; VIP Hosting</div>
            <h1 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[color:var(--tdt-ink)] mb-8">
              Culinary hosting, <em className="not-italic text-[color:var(--tdt-burgundy)]">polished and personal.</em>
            </h1>
            <p className="text-base sm:text-lg lg:text-lg leading-relaxed text-[color:var(--tdt-muted)] mb-5">
              Tour de Taste creates premium culinary experiences for client entertainment, executive hosting, incentive travel, conference guests and private corporate events.
            </p>
            <p className="text-base sm:text-lg lg:text-lg leading-relaxed text-[color:var(--tdt-muted)]">
              We design experiences that feel polished, personal and impressive — without ever feeling forced or overly formal.
            </p>
          </div>
        </div>
        <div className="lg:col-span-6 media-card relative min-h-[420px] lg:min-h-[640px]">
          <img src="/assets/photos/sommelier-decanting.jpg" alt="Sommelier decanting" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </section>

      <section className="bg-[color:var(--tdt-cream)] py-16 sm:py-14 sm:py-18 lg:py-32">
        <div className="max-w-[1200px] mx-auto px-5 sm:px-6 lg:px-12">
          <div className="max-w-2xl mb-14 reveal">
            <div className="tdt-eyebrow mb-5">Corporate Offers</div>
            <h2 className="font-serif font-light text-3xl sm:text-4xl md:text-5xl leading-[1.05] text-[color:var(--tdt-ink)]">
              Considered experiences for the moments that matter.
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-14">
            {OFFERS.map(([title, body], i) => (
              <div key={title} className="reveal" data-testid={`corp-offer-${i}`}>
                <div className="flex items-baseline gap-5 mb-4">
                  <span className="font-serif text-2xl text-[color:var(--tdt-gold)]">{String(i + 1).padStart(2, '0')}</span>
                  <h3 className="font-serif text-2xl lg:text-3xl text-[color:var(--tdt-ink)]">{title}</h3>
                </div>
                <div className="hr-gold mb-5" />
                <p className="text-[15px] sm:text-base lg:text-base leading-relaxed text-[color:var(--tdt-muted)]">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[color:var(--tdt-ink)] text-[color:var(--tdt-ivory)] py-16 sm:py-20 lg:py-36 relative overflow-hidden">
        <img src="/assets/photos/chefs-table-oysters.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-[color:var(--tdt-ink)]/65" />
        <div className="relative max-w-[900px] mx-auto px-5 sm:px-6 lg:px-12 text-center reveal">
          <div className="tdt-eyebrow tdt-eyebrow-light mb-5">Corporate Enquiries</div>
          <h2 className="font-serif font-light text-3xl sm:text-4xl md:text-5xl leading-[1.05] mb-7">Create a private experience for your guests.</h2>
          <p className="text-[color:var(--tdt-cream)] leading-relaxed max-w-xl mx-auto mb-10">
            Share your guest numbers, occasion, and desired tone. We will design and host an experience that reflects your organisation.
          </p>
          <Link to="/enquire" data-testid="corp-enquire-btn" className="btn-pill btn-gold">Enquire Privately</Link>
        </div>
      </section>
    </div>
  );
}
